export default "__VITE_ASSET__Despk9MB__"